import React from "react";
import { createPortal } from "react-dom";
import { HelpCircle, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

// Small round "?" button that opens a HelpGuide overlay.
export function HelpButton({ onClick, testid = "help-guide-btn", className = "" }) {
  return (
    <button onClick={onClick} data-testid={testid} title="Guide"
      className={`h-11 w-11 grid place-items-center rounded-full bg-[var(--rc-surface)] border border-[var(--rc-border)] text-[var(--rc-gold)] shrink-0 ${className}`}>
      <HelpCircle size={20} />
    </button>
  );
}

// Bottom-sheet / centered numbered-steps guide overlay.
export default function HelpGuide({ title, steps, onClose, testid = "help-guide-overlay" }) {
  const { t } = useI18n();
  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/60" onClick={onClose} data-testid={testid}>
      <div onClick={(e) => e.stopPropagation()} className="w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl bg-[var(--rc-surface)] border border-[var(--rc-border)] p-5 pb-6 rc-pop">
        <div className="flex items-center justify-between mb-3">
          <div className="font-heading text-xl text-[var(--rc-gold)]">{title}</div>
          <button type="button" onClick={onClose} data-testid="help-guide-close" className="h-8 w-8 grid place-items-center rounded-full hover:bg-[var(--rc-bg)]"><X size={18} /></button>
        </div>
        <ol className="space-y-3">
          {steps.map((s, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="shrink-0 h-7 w-7 grid place-items-center rounded-full bg-[var(--rc-gold)]/15 text-[var(--rc-gold)] text-xs font-bold">{i + 1}</span>
              <span className="text-sm text-[var(--rc-text)] pt-0.5 [overflow-wrap:anywhere]">{s}</span>
            </li>
          ))}
        </ol>
        <button type="button" onClick={onClose} data-testid="help-guide-gotit" className="mt-5 w-full rounded-full bg-[var(--rc-gold)] text-black font-semibold py-2.5">{t("guide_got_it")}</button>
      </div>
    </div>,
    document.body
  );
}
